/* ═══════════════════════════════════════════════
   Cinematic Hero — Scroll-to-Frame Canvas
   Requires: GSAP 3.12+ & ScrollTrigger
   ═══════════════════════════════════════════════ */

(function () {
  'use strict';

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('[cinematic-hero] GSAP or ScrollTrigger not loaded');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  var config = window.__cinematic_hero;
  if (!config) return;

  // Hidden on phones, upright and sideways (cinematic-hero.css, SAME query — keep in sync): don't
  // download ~3.5 MB of frames nobody can see, and don't pin an invisible scroll zone.
  // If it starts hidden, wait: a desktop window opened narrow and then widened shows the hero again
  // (CSS), so start it THEN — otherwise it would be a still poster over an empty scroll zone.
  var PHONE_QUERY = '(max-width: 749px), (orientation: landscape) and (max-height: 500px) and (pointer: coarse)';
  var phoneMq = window.matchMedia(PHONE_QUERY);
  if (!phoneMq.matches) {
    startHero();
  } else {
    var onPhoneChange = function (e) {
      if (e.matches) return;
      phoneMq.removeEventListener('change', onPhoneChange);
      startHero();
      ScrollTrigger.refresh(); // the scroll zone just became visible; re-measure every trigger
    };
    phoneMq.addEventListener('change', onPhoneChange);
  }

  function startHero() {
  var frameCount = config.frameCount || 121;
  var isMobile = window.matchMedia('(max-width: 989px)').matches;
  var baseUrl = isMobile ? config.mobileBase : config.desktopBase;
  var prefix = isMobile ? 'hero-m-' : 'hero-d-';

  /* ─── Frame URL builder ─── */
  function getFrameUrl(n) {
    var padded = String(n).padStart(3, '0');
    return baseUrl.replace(prefix + '001', prefix + padded);
  }

  /* ─── Canvas setup ─── */
  var canvas = document.getElementById('hero-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var images = new Array(frameCount);
  var canvasSized = false;
  var posterEl = document.querySelector('.hero-poster');

  function drawFrame(index) {
    var img = images[index];
    if (!img || !img.complete || img.naturalWidth === 0) return;
    if (!canvasSized) {
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvasSized = true;
    }
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  }

  /* ─── Frame loading ─── */
  function loadFrames() {
    for (var i = 0; i < frameCount; i++) {
      (function (index) {
        var img = new Image();
        img.onload = function () {
          images[index] = img;
          if (index === 0) {
            drawFrame(0);
            if (posterEl) posterEl.classList.add('is-hidden');
          }
        };
        img.src = getFrameUrl(index + 1);
        images[index] = img;
      })(i);
    }
  }

  /* ─── GSAP scroll-to-frame ─── */
  var frameObj = { frame: 0 };
  gsap.to(frameObj, {
    frame: frameCount - 1,
    snap: 'frame',
    ease: 'none',
    scrollTrigger: {
      trigger: '#hero-scroll-zone',
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.5
    },
    onUpdate: function () {
      drawFrame(Math.round(frameObj.frame));
    }
  });

  /* ─── Intro text animations ─── */
  // Each .hero-intro__* element is rendered CONDITIONALLY by cinematic-hero.liquid
  // (the whole overlay only when show_text_overlay is on; label/sub/cta only when
  // their text field is filled). Animating a selector GSAP can't find logs a
  // "target not found" warning, so only tween the elements actually in the DOM.
  // The relative offsets still stagger correctly when earlier tweens are skipped.
  var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
  [
    ['.hero-intro__label', { opacity: 1, y: 0, duration: 0.8 }, undefined],
    ['.hero-intro__heading', { opacity: 1, y: 0, duration: 1 }, '-=0.4'],
    ['.hero-intro__sub', { opacity: 1, y: 0, duration: 0.8 }, '-=0.5'],
    ['.hero-intro__cta', { opacity: 1, y: 0, duration: 0.6 }, '-=0.4'],
    ['.hero-intro__scroll', { opacity: 1, duration: 0.6 }, '-=0.3']
  ].forEach(function (t) {
    if (document.querySelector(t[0])) tl.to(t[0], t[1], t[2]);
  });

  /* ─── Header transparency ─── */
  var headerWrapper = document.querySelector('.header-wrapper');
  var heroIntro = document.querySelector('.hero-intro');
  if (headerWrapper && heroIntro) {
    headerWrapper.classList.add('header--transparent');

    function updateHeader() {
      var scrollY = window.scrollY || window.pageYOffset;
      var threshold = heroIntro.offsetHeight * 0.3;
      if (scrollY > threshold) {
        headerWrapper.classList.remove('header--transparent');
      } else {
        headerWrapper.classList.add('header--transparent');
      }
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ─── Start loading ─── */
  loadFrames();
  }
})();
